import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Preloader from '../components/Preloader';
import { API_ENDPOINTS } from '../config/api';

import axios from 'axios';
const url = API_ENDPOINTS.CHURCHES;

const Churches = (props) => {
  const { cached, updateCache, updateCountriesHandler } = props;
  const [tableMessage, setTableMessage] = useState('Loading data...');
  const [formData, setFormData] = useState({});
  const [disabled, setDisabled] = useState(false);
  const [countries, setCountries] = useState(cached.countries);
  const [churches, setChurches] = useState(null);
  const [updated, setUpdated] = useState({
    churches: false,
    countries: false,
  });

  useEffect(() => {
    if ( cached.countries ) {
      setCountries(cached.countries.sort((a, b) => (a.name > b.name) ? 1 : -1));
    } else if (!updated.countries) {
      setUpdated({...updated, countries: true});
      updateCountriesHandler();
    }

    if ( cached.churches ) {
      setChurches(cached.churches.sort((a, b) => (a.name > b.name) ? 1 : -1));
    } else if (!updated.churches) {
      setUpdated({...updated, churches: true});
      makeRequest('GET');
    }
  }, [JSON.stringify(cached?.countries), JSON.stringify(cached?.churches)]);

  const onChangeHandler = (e) => {
    const { name, value, type, checked } = e.currentTarget;
    const val = type === 'checkbox' ? checked : type === 'select' ? e.target.value : value;

    setFormData({
      ...formData,
      [name]: val,
    });
  }

  const onSubmitHandler = () => {
    if ( formData.id >= 0 ) {
      makeRequest('PUT');
    } else {
      makeRequest('POST');
    }
  }

  const clearFormHandler = () => {
    setFormData({});
  }

  const onDeleteHandler = (id) => {
    if (window.confirm('Do you really want to delete it?')) {
      makeRequest('DELETE', id);
    }
  }

  const makeRequest = (method, id) => {
    setDisabled(true);

    let requestUrl = url;
    let message = method === 'POST' ? 'Item is added' : 
                  method === 'PUT' ? 'Item is updated' :
                  method === 'DELETE' ? 'Item is deleted' : null;

    const requestData = {
      method: method,
      signal: AbortSignal.timeout(20000)
    };

    if ( method === 'POST' || method === 'PUT' ) {
      requestData.data = { ...formData };
    }

    if ( method === 'DELETE' || method === 'PUT' ) {
      const requestId = id ? id : formData.id;

      requestUrl += `/${requestId}`;
    }

    axios(requestUrl, requestData).then((response) => {
      clearFormHandler();

      if ( method === 'GET' ) {
        updateCache(response.data);
        setDisabled(false);
      } else {
        makeRequest('GET');
      }

      if ( message ) {
        toast.success(message, {
          position: 'top-right'
        });
      }
    }).catch( (error) => {
      let err = 'Error: ';

      if (error.response) {
        err += error.response.data.errors;
      } else if (error.request) {
        err += 'No response!';
      } else {
        err += error.message;
      }

      setTableMessage(err);

      toast.error(err, {
        position: 'top-right'
      });
      
      setDisabled(false);
    });
  }

  const updating = typeof countries === 'undefined' || typeof churches === 'undefined' ? true : false;

  return (
    <div style={{minHeight: 200}} className="container-fluid position-relative">
      { updating ? <Preloader /> : (
        <React.Fragment>
          <h2 className="mt-5">Churches</h2>

          <div className="mt-5">
            <div className="form-group row">
              <div className="col-12 form-group">
                <label className="form-label">Name</label>
                <input
                  type="text"
                  className="form-control"
                  disabled={disabled || updating}
                  placeholder="Name"
                  name="name"
                  onChange={(e) => onChangeHandler(e)}
                  value={formData.name || ''}
                />
              </div>
              <div className="col-3 form-group">
                <label className="form-label">City</label>
                <input
                  type="text"
                  className="form-control"
                  disabled={disabled || updating}
                  placeholder="City"
                  name="city"
                  onChange={(e) => onChangeHandler(e)}
                  value={formData.city || ''}
                />
              </div>
              <div className="col-3 form-group">
                <label className="form-label">State</label>
                <input
                  type="text"
                  className="form-control"
                  disabled={disabled || updating}
                  placeholder="State"
                  name="state"
                  onChange={(e) => onChangeHandler(e)}
                  value={formData.state || ''}
                />
              </div>
              <div className="col-3 form-group">
                <label className="form-label">Country</label>
                <select
                  value={formData.country || ''}
                  disabled={disabled || updating}
                  name="country"
                  onChange={(e) => onChangeHandler(e) } 
                  className="form-select"
                >
                  <option value=''>-</option>
                  { 
                    countries ? countries.map(c => {
                      return <option key={`country-option-${c.id}`} value={c.name}>{c.name}</option>;
                    }) : null 
                  }
                </select>
              </div>

              <div className="col-3 form-group">
                <label className="form-label">Zip Code</label>
                <input
                  type="text"
                  className="form-control"
                  disabled={disabled || updating}
                  placeholder="Zip Code"
                  name="zip_code"
                  onChange={(e) => onChangeHandler(e)}
                  value={formData.zip_code || ''}
                />
              </div>
              <div className="col-3 form-group">
                <label className="form-label">Address 1</label>
                <input
                  type="text"
                  className="form-control"
                  disabled={disabled || updating}
                  placeholder="Address 1"
                  name="address1"
                  onChange={(e) => onChangeHandler(e)}
                  value={formData.address1 || ''}
                />
              </div>
              <div className="col-3 form-group">
                <label className="form-label">Address 2</label>
                <input
                  type="text"
                  className="form-control"
                  disabled={disabled || updating}
                  placeholder="Address 2"
                  name="address2"
                  onChange={(e) => onChangeHandler(e)}
                  value={formData.address2 || ''}
                />
              </div>
              <div className="col-3 form-group">
                <label className="form-label">Latitude</label>
                <input
                  type="text"
                  className="form-control"
                  disabled={disabled || updating}
                  placeholder="Latitude"
                  name="latitude"
                  onChange={(e) => onChangeHandler(e)}
                  value={formData.latitude || ''}
                />
              </div>
              <div className="col-3 form-group">
                <label className="form-label">Longitude</label>
                <input
                  type="text"
                  className="form-control"
                  disabled={disabled || updating}
                  placeholder="Longitude"
                  name="longitude"
                  onChange={(e) => onChangeHandler(e)}
                  value={formData.longitude || ''}
                />
              </div>
              <div className="col-6 form-group">
                <label className="form-label">Email</label>
                <input
                  type="text"
                  className="form-control"
                  disabled={disabled || updating}
                  placeholder="Email"
                  name="email"
                  onChange={(e) => onChangeHandler(e)}
                  value={formData.email || ''}
                />
              </div>
              <div className="col-6 form-group">
                <label className="form-label">Phone</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Phone"
                  disabled={disabled || updating}
                  name="phone"
                  onChange={(e) => onChangeHandler(e)}
                  value={formData.phone || ''}
                />
              </div>
              <div className="col-6 form-group">
                <label className="form-label">Website URL</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Website URL"
                  disabled={disabled || updating}
                  name="website_url"
                  onChange={(e) => onChangeHandler(e)}
                  value={formData.website_url || ''}
                />
              </div>
              <div className="col-6 form-group">
                <label className="form-label">Cover Image URL</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Cover Image URL"
                  disabled={disabled || updating}
                  name="coverimage_url"
                  onChange={(e) => onChangeHandler(e)}
                  value={formData.coverimage_url || ''}
                />
              </div>

              <div className="col-6 form-group">
                <label>Facebook URL</label>
                <input
                  type="text"
                  className="form-control"
                  disabled={disabled || updating}
                  placeholder="Facebook URL"
                  name="facebook_url"
                  onChange={(e) => onChangeHandler(e)}
                  value={formData.facebook_url || ''}
                />
              </div>

              <div className="col-6 form-group">
                <label>LinkedIn URL</label>
                <input
                  type="text"
                  className="form-control"
                  disabled={disabled || updating}
                  placeholder="LinkedIn URL"
                  name="linkedin_url"
                  onChange={(e) => onChangeHandler(e)}
                  value={formData.linkedin_url || ''}
                />
              </div>

              <div className="col-6 form-group">
                <label>Instagram URL</label>
                <input
                  type="text"
                  className="form-control"
                  disabled={disabled || updating}
                  placeholder="Instagram URL"
                  name="instagram_url"
                  onChange={(e) => onChangeHandler(e)}
                  value={formData.instagram_url || ''}
                />
              </div>
            </div>

            <button disabled={disabled || updating} className="btn btn-primary me-2" onClick={() => onSubmitHandler()}>{formData.id >= 0 ? 'Update' : 'Add'}</button>
            <button disabled={disabled || updating} className="btn btn-secondary" onClick={() => clearFormHandler()}>Clear</button>
          </div>

          <table className="table table-hover mt-5">
            <thead className="thead-dark">
              <tr>
                <th scope="col">#</th>
                <th scope="col">Name</th>
                <th scope="col" style={{width: '100%'}}>Address</th>
                <th scope="col">Email</th>
                <th scope="col">Phone</th>
                <th scope="col">Website</th>
                <th scope="col">Image</th>
                <th scope="col">Social</th>
                <th scope="col">Actions</th>
              </tr>
            </thead>
            <tbody>
              { churches ? churches.map((item, index) => {
                return (
                  <tr key={`church-row-${index}`}>
                    <th scope="row">{index+1}</th>
                    <td>{item.name}</td>
                    <td>
                      { item.city ? <span><b>City:</b> {item.city}, </span> : null }
                      { item.address1 ? <span><b>Address:</b> {item.address1}, </span> : null }
                      { item.address2 ? <span><b>Address2:</b> {item.address2}, </span> : null }
                      { item.area ? <span><b>Area:</b> {item.area}, </span> : null }
                      { item.country ? <span><b>Country:</b> {item.country}, </span> : null }
                      { item.state ? <span><b>State:</b> {item.state}, </span> : null }
                      { item.zip_code ? <span><b>Zip Code:</b> {item.zip_code}, </span> : null }
                      { item.latitude ? <span><b>Latitude:</b> {item.latitude}, </span> : null }
                      { item.longitude ? <span><b>Longitude:</b> {item.longitude}</span> : null }
                    </td>
                    <td>{item.email ? <a href={`mailto:${item.email}`}>{item.email}</a> : '-'}</td>
                    <td>{item.phone ? <a href={`tel:${item.phone}`}>{item.phone}</a> : '-'}</td>
                    <td>{ item.website_url ? <i title={item.website_url}>YES</i> : '-' }</td>
                    <td>{ item.coverimage_url ? <i title={item.coverimage_url}>YES</i> : '-' }</td>
                    <td>
                      <div className='social-icons-wrapper'>
                        { item.facebook_url ? <a href={item.facebook_url} target="_blank">
                          <img src={require('../assets/images/Facebook.png')} className="social-icon" alt="Facebook" title="Facebook" />
                        </a> : null }
                        { item.linkedin_url ? <a href={item.linkedin_url} target="_blank">
                          <img src={require('../assets/images/Linkedin.png')} className="social-icon" alt="LinkedIn" title="LinkedIn" />
                        </a> : null }
                        { item.instagram_url ? <a href={item.instagram_url} target="_blank">
                          <img src={require('../assets/images/Instagram.png')} className="social-icon" alt="Instagram" title="Instagram" />
                        </a> : null }
                      </div>
                    </td>
                    <td style={{whiteSpace: 'nowrap'}}>
                      <button className="btn btn-danger me-1" onClick={() => onDeleteHandler(item.id)}>Delete</button>
                        <button className="btn btn-primary ms-1" onClick={() => {
                          setFormData({ ...item });
                          window.scrollTo(0, 0);
                        }}>Edit</button>
                    </td>
                </tr>
                );
              }) : <tr><td style={{textAlign: 'center', padding: 32}} colSpan="8">{tableMessage}</td></tr> }
            </tbody>
          </table>
        </React.Fragment>
      )}
    </div>
  );
}

export default Churches;
